/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

import { MSEnum } from '../../common/enumeration';
export default {
	updateEmailList(state, res) {
		state.EmailList.removeAll();
		state.EmailList.append(res.Data);
	},
	updateEmailTotal(state, res) {
		if (typeof res == 'number') {
			state.EmailTotal = res;
		}
	},
	updateEmailSpamList(state, res) {
		state.SpamEmailList.removeAll();
		state.SpamEmailList.append(res.Data);
	},
	updateSpamEmailTotal(state, res) {
		if (typeof res == 'number') {
			state.SpamEmailTotal = res;
		}
	},
	clearEmailList(state) {
		state.EmailList.removeAll();
	},
	clearSpamEmailList(state) {
		state.SpamEmailList.removeAll();
	},
	clearTrashEmailList(state) {
		state.TrashEmailList.removeAll();
	},
	appendEmailList(state, res) {
		state.EmailList.append(res.Data);
	},
	appendEmailSpamList(state, res) {
		state.SpamEmailList.append(res.Data);
	},
	appendEmailTrashList(state, res) {
		state.TrashEmailList.append(res.Data);
	},
	updateEmailTrashList(state, res) {
		state.TrashEmailList.removeAll();
		state.TrashEmailList.append(res.Data);
	},
	updateTrashEmailTotal(state, res) {
		if (typeof res == 'number') {
			state.TrashEmailTotal = res;
		}
	},
	updateWidthSize(state, res) {
		state.widthSize = res;
	},
	updateEmail(state, res) {
		let emailIndex = state.EmailList.findIndex(item => {
			return item.Id == res.Id;
		});
		if (emailIndex >= 0) {
			state.EmailList.splice(emailIndex, 1, res);
		} else if (res.statusPushEmail == 'New') {
			if (res.typePushEmail == 'NewEmail') {
				state.EmailWaitingTotal++;
				//Thư mới vào hệ thống(số lượng thư chưa đọc tăng lên 1)
				state.TotalEmailUnReadV2++;
			} else if (res.typePushEmail == 'EmailSpam') {
				state.EmailSpamWaitingTotal++;
			}
		}
	},
	resetReaded(state, res) {
		// state.TotalEmailUnReadV2 = 0;
	},
	updateUnread(state, res) {
		if (state.TotalEmailUnReadV2 > 0 && res && res.ComponentName == 'Inbox') {
			state.TotalEmailUnReadV2--;
		}
	},
	updateListEmailByDelete(state, res) {
		if (res && res.length > 0) {
			res.forEach(element => {
				let emailIndex = state.EmailList.findIndex(item => {
					return item.Id == element;
				});
				if (emailIndex >= 0) {
					state.EmailList.splice(emailIndex, 1);
					state.EmailTotal--;
				}
			});
		}
	},
	updateEmailSpam(state, res) {
		if (res.isSpam) {
			if (state.EmailList && state.EmailList.length > 0) {
				res.emailIds.forEach(element => {
					let emailIndex = state.EmailList.findIndex(item => {
						return item.Id == element;
					});
					if (emailIndex >= 0) {
						state.EmailList.splice(emailIndex, 1);
						state.EmailTotal--;
					}
				});
			}
		} else {
			if (state.SpamEmailList && state.SpamEmailList.length > 0) {
				res.emailIds.forEach(element => {
					let emailIndex = state.SpamEmailList.findIndex(item => {
						return item.Id == element;
					});
					if (emailIndex >= 0) {
						state.SpamEmailList.splice(emailIndex, 1);
						state.SpamEmailTotal--;
					}
				});
			}
		}
	},

	updateListSpamEmailByDelete(state, res) {
		let emailIndex = state.SpamEmailList.findIndex(item => {
			return item.Id == res;
		});
		if (emailIndex >= 0) {
			state.SpamEmailList.splice(emailIndex, 1);
			state.SpamEmailTotal--;
		}
	},

	updateListSpamEmailByDelete1(state, res) {
		if (res && res.length > 0) {
			res.forEach(element => {
				let emailIndex = state.SpamEmailList.findIndex(item => {
					return item.Id == element;
				});
				if (emailIndex >= 0) {
					state.SpamEmailList.splice(emailIndex, 1);
					state.SpamEmailTotal--;
				}
			});
		}
	},

	updateNotReadEmailList(state, res) {
		if (typeof res == 'number') {
			state.TotalEmailUnReadV2 = res;
		}
	},

	updateNotReadEmailList1(state, res) {
		if (typeof res == 'number') {
			state.TotalEmailUnReadV2 += res;
		}
	},

	resetTotalEmailWaiting(state, res) {
		state.EmailWaitingTotal = 0;
		state.EmailSpamWaitingTotal = 0;
	},

	updateTotalEmailUnRead(state, payload) {
		if (!payload) return;
		if (payload.updateType == MSEnum.UpdateType.Increase) {
			state.TotalEmailUnReadV2 += payload.total;
		} else if (payload.updateType == MSEnum.UpdateType.Decrease) {
			state.TotalEmailUnReadV2 -= payload.total;
		}

		if (state.TotalEmailUnReadV2 <= 0) state.TotalEmailUnReadV2 = 0;
	},

	updateHasAnyEmail(state, val) {
		state.hasAnyEmail = val;
	}
};
